(ns profile.common
  (:require [very.re-frame.core :as rf]
            [css.core :refer [defstyled get-theme]]
            [cljss.core :as cljss]
            [css.vars :as vars]))

(defstyled form-section-s :section
  {:margin-top "100px"
   ::cljss/media {[[:max-width "768px"]]
                  {:margin-top "50px"}}})

(defstyled form-section-header-s :div
  {:display "flex"
   :justify-content "space-between"
   :width "100%"
   :border-bottom (str "2px solid " (get-theme :primary))
   :padding-bottom "15px"
   :margin-bottom "15px"})

(defstyled form-section-title-s :h2
  {:font-size "24px"
   :color "#282828"
   :font-weight "400"
   :margin-bottom "5px"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "20px"}}})

(defstyled form-section-total-s :h2
  {:font-size "24px"
   :color (get-theme :primary)
   :font-weight "400"
   :margin-bottom "5px"
   ::cljss/media {[[:max-width "768px"]]
                  {:font-size "20px"}}})

(defstyled column-wrapper-s :div
  {:display "grid"
   :grid-template-columns "1fr 1fr"
   :margin (with-meta #(or % 0) :margin)
   :width "100%"
   :grid-column-gap "60px"
   ::cljss/media {[[:max-width "768px"]]
                  {:grid-template-columns "1fr"}}})

(defstyled form-column-s :div
  {:margin (with-meta #(or % 0) :margin)})

(defstyled form-section-description-s :div
  {:color vars/gray
   :line-height "24px"
   :margin (with-meta #(if % % "0") :margin)})

(defstyled column-title-s :h3
  {:font-size "20px"
   :margin "35px 0 20px"})
